import { ParsedUrlQuery } from 'node:querystring';

import { GetServerSideProps, NextPage } from 'next';

import urls from '@/constants/url';
import PageSingle from '@/features/page';
import { Page } from '@/features/page/types';
import { textVariableReplacer } from '@/helpers/common';
import serverSideFetch from '@/utils/fetch';

type Params = ParsedUrlQuery & {
  path: string[];
};

type Props = {
  data: Page;
};
const Homepage: NextPage<Props> = ({ data }) => <PageSingle {...data} isHomepage />;

export const getServerSideProps: GetServerSideProps<Props, Params> = async ({ req }) => {
  const pageData = await serverSideFetch<Page>(
    req,
    textVariableReplacer(urls.content.settingPage, { setting: 'homepage' }),
    {}
  );

  if (!pageData) {
    return {
      notFound: true
    };
  }

  return {
    props: {
      data: pageData
    }
  };
};

export default Homepage;
